import React from 'react'
import { Link } from 'react-router-dom'

function NotFound() {
  return (
    <div className="not-found flex flex-col items-center justify-center py-20 bg-white rounded-2xl shadow-sm border border-slate-100 max-w-lg mx-auto mt-10">
      <div className="text-9xl font-black text-slate-100 mb-4 select-none">404</div>
      <h2 className="text-3xl font-bold text-slate-800 mb-2 z-10 -mt-16">Page Not Found</h2>
      <p className="text-slate-500 mb-8 z-10">Sorry, the page you're looking for doesn't exist.</p>
      <Link to="/" className="bg-primary text-white px-6 py-2 rounded-full font-medium hover:bg-rose-600 transition-colors shadow-md hover:shadow-lg z-10">
        Back to Homepage
      </Link>
    </div>
  )
}

export default NotFound